import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable, of, retry, Subject, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { API_ENDPOINTS } from '../utils/const';

@Injectable({
  providedIn: 'root'
})
export class AutofillmsmeService {

  msme_hasudyam: any;
  private dataSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public readonly data$: Observable<any[]> = this.dataSubject.asObservable();


  private insert_dataSubject = new Subject<any>();
  public readonly insert_data$: Observable<any> = this.insert_dataSubject.asObservable();

  private getMSMEUser_dataSubject = new Subject<any>();
  public readonly getMSMEUser_data$: Observable<any> = this.getMSMEUser_dataSubject.asObservable();

  //data: any[] = [];

  constructor(private http: HttpClient) {
    this.msme_hasudyam = '';
  }

  getRegisteredUserData() {
    this.http.get<any>('autofillmsme.json')
      .subscribe(data => {
        this.dataSubject.next(data);
      });

    // this.http.get<any>('http://localhost:3000/0')
    // .subscribe(data => {
    //   this.dataSubject.next(data);
    // });   
  }

  getDataByUdyamNumber(u_num: string | null): Promise<any>  {
    const jsonUrl = 'assets/autofillmsme.json';
    return this.http.get<any[]>(jsonUrl).pipe(
      map(data => {
        const item = data.find(item => item.udyamRegistrationNumber === u_num);
        this.insert_dataSubject.next(item);
        return item;
      })
    ).toPromise();
  }

  verifyUdyamAndMobile(u_num: string, mobile: string): Promise<any> {
    const jsonUrl = 'assets/autofillmsme.json';
    return this.http.get<any[]>(jsonUrl).pipe(
      map(data => {
        // Find the record where both udyamRegistrationNumber and ownersMobileNumber match
        const item = data.find(item =>
          item.udyamRegistrationNumber === u_num && item.ownersMobileNumber === mobile
        );

        // Publish the result to the next subject
        this.insert_dataSubject.next(item);

        // Return the item if found, otherwise return null
        return item;// ? item : null;
      })
    ).toPromise();
  }


  SaveRegisterData(insert_obj: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': '*/*'
      })
    };
    return this.http.post<any>(environment.api_url + 'msme/saveuser', insert_obj, httpOptions);
  }

  verifyMsMeUserCredentials(formDataValue: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': '*/*'
      })
    };
    return this.http.post<any>(/*environment.api_url + 'msme/login'*/API_ENDPOINTS.register, formDataValue, httpOptions);
  }

  getRegisteredMSMEUserDetails(u_num: any): Observable<any> {
    let params = new HttpParams().set('dtoUdyamNumber', u_num);
    return this.http.get(`${environment.api_url}msme/getuserbyudyamno`, { params });

    // return this.http.get(Envsetting.apiBaseUrl+'msme/getuserbyudyamno?dtoUdyamNumber='+u_num,u_num); 
  }

  verifyOTP(otpdata: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': '*/*'
      })
    };
    return this.http.post<any>(environment.api_url + 'notification/verifyOtp', otpdata, httpOptions);
  }

  sendOTP(otpdata: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': '*/*'
      })
    };
    return this.http.post<any>(environment.api_url + 'notification/sendOtp', otpdata, httpOptions);
  }

  getInterests(): Promise<any> {
    return this.http.get(environment.api_url + 'interest/getlist').toPromise();
  }

  forgotPassword(passwordData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': '*/*'
      })
    };
    return this.http.post<any>(environment.apiBaseUrl + 'msme/password/update', passwordData, httpOptions);
  }
}
